<div class="ui-scale" (click)="$event.stopPropagation()">
  <div class="ui-scale-header">
    <span class="ui-scale-title">Display Size</span>
    <span class="ui-scale-value" *ngIf="preferredScale !== 1">
      <button type="button" class="ui-scale-reset" (click)="select(1, $event)">Reset</button>
    </span>
  </div>
  <div class="ui-scale-options" role="radiogroup" aria-label="Display size">
    <button type="button" class="ui-scale-option" *ngFor="let level of levels"
      role="radio" [attr.aria-checked]="level.scale === effectiveScale"
      [attr.aria-label]="level.label + ' (' + percent(level.scale) + '%)'"
      [class.active]="level.scale === effectiveScale" [disabled]="!isAllowed(level.scale)"
      [attr.title]="isAllowed(level.scale) ? percent(level.scale) + '%' : 'Needs a wider screen'"
      (click)="select(level.scale, $event)">
      {{ level.label }}
    </button>
  </div>
  <div class="ui-scale-note" *ngIf="isCapped">
    {{ labelFor(preferredScale) }} applies on wider screens
  </div>
</div>
